<script>
import "./style.scss";
import template from "./template.html";
import {Event} from "vue-tables-2";
import axios from 'axios';
import {LoadingIcon} from "../../icons.js";
import moment from 'moment';

export default {
  template,
  components: {
    LoadingIcon,
  },
  props: {
    pageData: {
      type: Array,
      default: () => [],
    },
    adminFilesUrl: {
      type: String,
      default: '',
    },
    adminConnectorsUrl: {
      type: String,
      default: '',
    },
    pageDeleteUrl: {
      type: String,
      default: '',
    },
    pageCreateUrl: {
      type: String,
      default: '',
    },
  },
  created () {
    Event.$on("vue-tables.refresh-table", () => {
      this.$refs.table.refresh();
    });
    this.localPageData = JSON.parse(JSON.stringify(this.pageData));
  },
  computed: {
    tableData () {
      return this.localPageData;
    },
  },
  methods: {
    getPageUrl (pageName, contentSlot) {
      return (contentSlot) ? "javascript:void(0);" : '/pages/' + pageName;
    },
    getPageEditUrl (pageId) {
      return '/admin/pages/' + pageId;
    },
    pageOnclick (pageName, contentSlot) {
      return (contentSlot) ? `showPopupPage('${pageName}', 'Content Slot: ${pageName}')` : '';
    },
    getAttributeText (data) {
      let attributeText = (data.content_slot) ? 'Content Slot, ' : '';
      if (data.escaped_text == 0) attributeText += 'Unescaped Script, ';
      if (attributeText.length) attributeText = attributeText.slice(0, -2);
      return attributeText;
    },
    getTitle (data) {
      return (data && data.title) ?? '';
    },
    isCustomPage (data) {
      return (data && data.is_custom_page == 1);
    },
    getPageSettingsType (data) {
      let pageSettingText = (data && data.post_login_notification) ? 'Portal Announcement' : '';
      if (data && data.show_on_developer_dashboard) pageSettingText = 'Developer Portal';
      return pageSettingText;
    },
    showDeletePageConfirmation (pageId) {
      popupConfirm('Are you sure you want to delete this page?', 'Delete?', () => {
        this.isLoading = true;
        let errorMessage = 'Error occured while deleting page. Please try again';
        axios.post(this.pageDeleteUrl, {id: pageId})
            .then((response) => {
              if (response.data.success) {
                this.localPageData = this.localPageData.filter((row) => {
                  return row.id !== pageId;
                });
              }
              else {
                popupAlert(errorMessage, "Error");
              }
              this.isLoading = false;
            }).catch((err) => {
          popupAlert(errorMessage, "Error");
          this.isLoading = false;
        });
      });
    },
    ShowAddPagePopup () {
      this.setPageAddLabel('', false);
      this.$modal.show('add-page', {});
    },
    pageAddKeyup () {
      this.setPageAddLabel('', false);
    },
    hideModal () {
      this.$modal.hide('add-page');
    },
    appendNewPagetoTable (data) {
      this.localPageData.unshift(data);
    },
    setPageAddLabel (msgText, error) {
      this.pageAddResponse = msgText;
      this.error = error;
    },
    addPage () {
      this.isLoading = true;
      let addPageData = {name: this.newPageSlug};
      axios.post(this.pageCreateUrl, addPageData)
          .then((response) => {
            if (response.data.success) {
              this.setPageAddLabel('Page Created Successfully!!', false);
              this.appendNewPagetoTable(response.data.data);
              setTimeout(() => {
                this.hideModal();
              }, 1000);
            }
            else {
              this.setPageAddLabel('Error adding page. Please try again.', true);
            }
            this.isLoading = false;
          }).catch(({response}) => {
        if (response.status == 422) {
          this.setPageAddLabel(response.data.errors.name.pop(), true);
        }
        this.isLoading = false;
      });
    },
    showPageSettings (data) {
      return (data && (data.show_on_developer_dashboard || data.post_login_notification));
    },
    getTooltipText (data) {
      let tooltipText = '';
      if (data && data.show_on_developer_dashboard) {
        tooltipText = 'Display: Yes <br>';
        tooltipText += (data.is_developer_homepage) ? 'Is Homepage: Yes' : 'Is Homepage: No';
        tooltipText += '<br> Navbar Position: ' + data.navbar_position || 0;
      }
      else if (data && data.post_login_notification) {
        let startDate = this.formatDate(data.notification_start_date);
        let endDate = this.formatDate(data.notification_end_date);
        let userCount = Object.keys(data.userIds || {}).length;
        let totalViews = data.totalViews || 0;
        tooltipText = `Start: ${startDate}<br>
                        End: ${endDate}<br>Unique Views: ${userCount}<br>Total Views: ${totalViews}`;
      }
      return tooltipText;
    },
    formatDate (date) {
      if (date && moment(date).isValid()) {
        return moment(date).format('DD-MMM-YYYY HH:mm');
      }
      return '';
    }
  },
  data () {
    return {
      columns: ['Page', 'Operations', 'Description', 'Attributes', 'Title', 'Page Settings'],
      tableOptions: {
        perPage: 50,
        sortable: [],
        filterByColumn: true,
        filterable: [
          "Page Settings"
        ],
        listColumns: {
          "Page Settings": [
            {
              "id": "show_on_developer_dashboard",
              "text": "Developer Portal "
            },
            {
              "id": "post_login_notification",
              "text": "Portal Announcement"
            }
          ]
        },
        filterAlgorithm: {
          "Page Settings" : (row, query) =>  {
            return row?.properties?.[query] === true
          }
        }
      },

      localPageData: [],
      isLoading: false,
      newPageSlug: '',
      pageAddResponse: '',
      error: false
    };
  },
};
</script>
